import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AlertsPage from "@/pages/AlertsPage";
import EnergyPage from "@/pages/EnergyPage";
import AnnualPage from "@/pages/AnnualPage";
import ProjectsPage from "@/pages/ProjectsPage";
import DashboardPage from "@/pages/DashboardPage";
import FaultsPage from "@/pages/FaultsPage";
import SitesPage from "@/pages/SitesPage";
import SiteDetailPage from "@/pages/SiteDetailPage";
import SiteEnergyPage from "@/pages/SiteEnergyPage";
import EquipmentPage from "@/pages/EquipmentPage";
import AuthCallback from "@/pages/AuthCallback";
import AxonPage from "@/pages/AxonPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        element={
          <ProtectedRoute>
            <ProjectProvider>
              <AppShell />
            </ProjectProvider>
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/faults" element={<FaultsPage />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/sites/:siteId" element={<SiteDetailPage />} />
        <Route path="/sites/:siteId/energy" element={<SiteEnergyPage />} />
        <Route path="/sites/:siteId/equipment" element={<EquipmentPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/energy" element={<EnergyPage />} />
        <Route path="/energy/annual" element={<AnnualPage />} />
        <Route
          path="/projects"
          element={
            <ProtectedRoute adminOnly>
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/axon"
          element={
            <ProtectedRoute adminOnly>
              <AxonPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              color: "#212121",
              border: "1px solid #E5E7EB",
              fontFamily: "Open Sans, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
